<template>
  <div class="form-container">
    <div class="form-title margin-b20">表1-基本资质审查</div>
    <div class="table-wrapper table-1">
      <div class="table-header-wrapper">
        <div class="table-header">
          <div class="table-header-item one">评价项目</div>
          <div class="table-header-item two">评价内容</div>
          <div class="table-header-item three">合格条件</div>
          <div class="table-header-item four">备注</div>
        </div>
      </div>
      <div class="table-body-wrapper">
        <div class="table-body">
          <div class="table-body-item">
            <div class="one">
              {{ evaluationBasicQualificationList[0].auditItem }}
            </div>
            <div class="two">
              <Tooltip
                :content="evaluationBasicQualificationList[0].auditContent"
              ></Tooltip>
            </div>
            <div class="three">
              <Tooltip
                :content="evaluationBasicQualificationList[0].eligibility"
              ></Tooltip>
            </div>
            <div class="four">
              <Tooltip
                :content="evaluationBasicQualificationList[0].remark"
              ></Tooltip>
            </div>
          </div>
          <div class="table-body-item">
            <div class="one">生产经营资质</div>
            <div class="two" style="display: block">
              <div class="table-body-wrapper-inner" style="display: block">
                <div class="table-body-inner">
                  <div
                    class="table-body-item-inner"
                    v-for="(item, index) in evaluationBasicQualificationList[1]
                      .children"
                    :key="index"
                  >
                    <div class="two">{{ item.auditContent }}</div>
                    <div class="one">
                      <div
                        v-if="item.required === 1"
                        style="display: flex; align-items: center"
                      >
                        <eui-icon
                          icon="eicon-check-press"
                          color="#D9D9D9"
                          font-size="16px"
                          style="margin-right: 10px"
                        />
                        必填项
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="three" style="display: block">
              <div class="table-body-wrapper-inner">
                <div class="table-body-inner">
                  <div
                    class="table-body-item-inner"
                    v-for="(item, index) in evaluationBasicQualificationList[1]
                      .children"
                    :key="index"
                  >
                    <div class="two">{{ item.eligibility }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="four" style="display: block">
              <div class="table-body-wrapper-inner" style="display: block">
                <div class="table-body-inner">
                  <div
                    class="table-body-item-inner"
                    v-for="(item, index) in evaluationBasicQualificationList[1]
                      .children"
                    :key="index"
                  >
                    <div class="two">{{ item.remark }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-wrapper table-1">
      <div class="table-body-wrapper">
        <div class="table-body">
          <div class="table-body-item">
            <div class="one">
              {{ evaluationBasicQualificationList[2].auditItem }}
            </div>
            <div class="two">
              <Tooltip
                :content="evaluationBasicQualificationList[2].auditContent"
              ></Tooltip>
            </div>
            <div class="three">
              <Tooltip
                :content="evaluationBasicQualificationList[2].eligibility"
              ></Tooltip>
            </div>
            <div class="four">
              <Tooltip
                :content="evaluationBasicQualificationList[2].remark"
              ></Tooltip>
            </div>
          </div>
          <div
            class="table-body-item"
            v-if="evaluationBasicQualificationList.length > 3"
          >
            <div class="one">其他</div>
            <div class="two" style="display: block">
              <div class="table-body-wrapper-inner" style="display: block">
                <div class="table-body-inner">
                  <div
                    class="table-body-item-inner"
                    v-for="(item, index) in evaluationBasicQualificationList[3]
                      .children"
                    :key="index"
                  >
                    <div class="two">{{ item.auditContent }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="three" style="display: block">
              <div class="table-body-wrapper-inner">
                <div class="table-body-inner">
                  <div
                    class="table-body-item-inner"
                    v-for="(item, index) in evaluationBasicQualificationList[3]
                      .children"
                    :key="index"
                  >
                    <div class="two">{{ item.eligibility }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="four" style="display: block">
              <div class="table-body-wrapper-inner" style="display: block">
                <div class="table-body-inner">
                  <div
                    class="table-body-item-inner"
                    v-for="(item, index) in evaluationBasicQualificationList[3]
                      .children"
                    :key="index"
                  >
                    <div class="two">{{ item.remark }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tooltip from './tooltip.vue';
export default {
  props: {
    evaluationBasicQualificationList: {
      type: Array,
      default: () => [
        {
          auditItem: '基本资质',
          auditContentCode: '',
          auditContent: '',
          required: 0,
          eligibility: '',
          remark: '',
          sortNum: 1
        },
        { auditItem: '生产经营资质', children: [] },
        {
          auditItem: '诚信情况',
          auditContentCode: '',
          auditContent: '',
          required: 0,
          eligibility: '',
          remark: '',
          sortNum: 1
        },
        { auditItem: '其他', children: [] }
      ]
    }
  },
  data() {
    return {};
  },
  components: { Tooltip },
  computed: {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.text-overflow {
  display: inline-block;
  width: calc(100% - 20px);
  height: 100%;
  line-height: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.table-1 {
  .table-header {
    height: 40px;
    display: flex;
    background: #f5f5f5;
    border: 1px solid #dcdcdc;
    .table-header-item {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #333;
      font-size: 12px;
      font-weight: 500;
      border-right: 1px solid #dcdcdc;
      &:last-child {
        border-right: none;
      }
    }
    .one {
      flex: 1;
      min-width: 90px;
    }
    .two {
      flex: 2;
    }
    .three {
      flex: 2;
    }
    .four {
      flex: 2;
    }
  }
  .table-body-wrapper {
    border: 1px solid #dcdcdc;
    border-top: none;
    .table-body {
      .table-body-item {
        min-height: 50px;
        display: flex;
        color: #333;
        font-size: 12px;
        font-weight: 500;
        border-top: 1px solid #dcdcdc;
        &:first-child {
          border-top: none;
        }
        & > div {
          display: flex;
          justify-content: center;
          align-items: center;
          border-right: 1px solid #dcdcdc;
          /* 有overflow: hidden; 表格布局完美; 没有overflow: hidden; 表格布局乱了就  */
          overflow: hidden;
          white-space: nowrap;
          &:last-child {
            border-right: none;
          }
        }
        .one {
          flex: 1;
          min-width: 90px;
        }
        .two {
          flex: 2;
        }
        .three {
          flex: 2;
          /* 有overflow: hidden; 表格布局完美; 没有overflow: hidden; 表格布局乱了就  */
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .four {
          flex: 2;
        }
      }
    }
  }
}
.table-body-wrapper-inner {
  border-top: none;
  .table-body-inner {
    .table-body-item-inner {
      min-height: 50px;
      display: flex;
      color: #333;
      font-size: 12px;
      font-weight: 500;
      border-top: 1px solid #dcdcdc;
      &:first-child {
        border-top: none;
      }
      & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #dcdcdc;
        &:last-child {
          border-right: none;
        }
      }
      .one {
        flex: 2;
      }
      .two {
        flex: 1;
      }
      .three {
        flex: 2;
      }
      .four {
        flex: 2;
      }
    }
  }
}
</style>
